import React from 'react';
import { StarIcon } from 'lucide-react';
import { writtenReviews } from '../data/reviews';
import { useSnapIndex } from '../hooks/useSnapIndex';
import { CarouselDots } from './CarouselDots';
export function ReviewsList() {
  const {
    ref,
    index,
    scrollTo
  } = useSnapIndex<HTMLUListElement>();
  return <div className="mt-8 sm:mt-12" data-id="element-68" data-mp="1ewpjxd3v0elf">
      <ul ref={ref} className="no-scrollbar relative -mx-5 flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-2 lg:mx-0 lg:grid lg:grid-cols-6 lg:gap-5 lg:overflow-visible lg:px-0" data-id="element-69" data-mp="1exqznuvtlp9h">
        {writtenReviews.map((r, i) => <li key={r.name} className={`flex w-[82%] shrink-0 snap-center flex-col rounded-2xl bg-paper p-5 ring-1 ring-beige-200 sm:w-[55%] lg:w-auto lg:p-6 ${i < 3 ? 'lg:col-span-2' : 'lg:col-span-3'}`} data-id="element-70" data-mp="1ttgnzzohaehd" data-mpi={i}>
            <div className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-71" data-mp="3haq2i6y62uj">
              {Array.from({
            length: 5
          }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-72" data-mp="ccxu5o54091q" data-mpi={s} />)}
            </div>
            <blockquote className="mt-3 text-[15px] leading-relaxed text-ink/80" data-id="element-73" data-mp="7j329xfconrk">“{r.quote}”</blockquote>
            <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-74" data-mp="2jyrx3gowjzn">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sage-100 font-serif text-base text-petrol-800" aria-hidden="true" data-id="element-75" data-mp="3ttp45rc969n4">
                {r.name.charAt(0)}
              </span>
              <div className="min-w-0 leading-tight" data-id="element-76" data-mp="lc1d8s4a0og8">
                <p className="font-semibold text-petrol-800" data-id="element-77" data-mp="lenn4yen3g1m">{r.name}</p>
                <p className="text-[13px] text-ink/60" data-id="element-78" data-mp="gcoi7k394b2k">{r.profession}</p>
              </div>
            </div>
          </li>)}
      </ul>
      <CarouselDots count={writtenReviews.length} active={index} onSelect={scrollTo} className="mt-3 lg:hidden" data-id="element-79" data-mp="313oz9shr4wk9" />
    </div>;
}